import React from 'react';

import PropTypes from '../../js/PropTypes';

// import './Icon.css';

export const icons = {
  account: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M12 15c-4.050 0-12 1.95-12 6v3h24v-3c0-4.050-7.95-6-12-6zM12 12c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z',
      },
    ],
  },
  'open-link': {
    viewBox: '0 0 24 24',
    paths: [
      {
        d: 'M0 0h24v24H0z',
        fill: 'none',
      },
      {
        d:
          'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
      },
    ],
  },
  activity: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M9.797 8.906l-2.813 14.109h2.109l1.828-8.016 2.063 2.016v6h2.016v-7.5l-2.109-2.016 0.609-3c1.313 1.5 3.281 2.484 5.484 2.484v-1.969c-1.922 0-3.469-1.031-4.266-2.438l-1.031-1.594c-0.422-0.609-0.984-0.984-1.688-0.984-0.281 0-0.516 0.094-0.797 0.094l-5.203 2.203v4.688h2.016v-3.375l1.781-0.703zM13.5 5.484c-1.078 0-2.016-0.891-2.016-1.969s0.938-2.016 2.016-2.016 2.016 0.938 2.016 2.016-0.938 1.969-2.016 1.969z',
      },
    ],
  },
  'cancel-circle': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM21 8l-5 5-5-5-3 3 5 5-5 5 3 3 5-5 5 5 3-3-5-5 5-5z',
      },
    ],
  },
  'check-circle': {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M9.984 17.016l9-9-1.406-1.453-7.594 7.594-3.563-3.563-1.406 1.406zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984z',
      },
    ],
  },
  'carousel-arrow-left': {
    viewBox: '0 0 18 32',
    paths: [
      {
        d:
          'M15.84 0l-15.84 16 15.84 16 1.498-1.373-14.472-14.627 14.472-14.627-0.296-0.272z',
      },
    ],
  },
  'carousel-arrow-right': {
    viewBox: '0 0 18 32',
    paths: [
      {
        d:
          'M1.498 0l15.84 16-15.84 16-1.498-1.373 14.472-14.627-14.472-14.627 0.296-0.272z',
      },
    ],
  },
  checkmark: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d: 'M27 4l-15 15-7-7-5 5 12 12 20-20z',
      },
    ],
  },
  'chevron-left': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M25.875 3.749l-12.251 12.251 12.251 12.251-3.749 3.749-16-16 16-16z',
      },
    ],
  },
  'chevron-right': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d: 'M6.125 28.251l12.251-12.251-12.251-12.251 3.749-3.749 16 16-16 16z',
      },
    ],
  },
  'chevron-down': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d: 'M3.749 6.125l12.251 12.251 12.251-12.251 3.749 3.749-16 16-16-16z',
      },
    ],
  },
  'chevron-up': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M28.251 25.875l-12.251-12.251-12.251 12.251-3.749-3.749 16-16 16 16z',
      },
    ],
  },
  clock: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M12.516 6.984v5.25l4.5 2.672-0.75 1.266-5.25-3.188v-6h1.5zM12 20.016c4.406 0 8.016-3.609 8.016-8.016s-3.609-8.016-8.016-8.016-8.016 3.609-8.016 8.016 3.609 8.016 8.016 8.016zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984z',
      },
    ],
  },
  close: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M17.4 16l10.6 10.6-0.6 0.8-0.8 0.6-10.6-10.6-10.6 10.6-0.8-0.6-0.6-0.8 10.6-10.6-10.6-10.6 0.6-0.8 0.8-0.6 10.6 10.6 10.6-10.6 0.8 0.6 0.6 0.8z',
      },
    ],
  },
  'double-chevron-left': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M32 4.887l-9.942 11.113 9.942 11.113-3.055 3.433-12.945-14.545 12.945-14.545z M16 4.887l-9.942 11.113 9.942 11.113-3.055 3.433-12.945-14.545 12.945-14.545z',
      },
    ],
  },
  'double-chevron-right': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M0 4.887l9.942 11.113-9.942 11.113 3.055 3.433 12.945-14.545-12.945-14.545z M16 4.887l9.942 11.113-9.942 11.113 3.055 3.433 12.945-14.545-12.945-14.545z',
      },
    ],
  },
  facebook: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M11.333 6.19v4.285h-3.333v5.475h3.333v16.069h6.428v-16.069h4.523l0.476-5.356h-4.999v-3.095c0-1.309 0.238-1.785 1.547-1.785h3.452v-5.714h-4.523c-4.761 0-6.904 2.143-6.904 6.19z',
      },
    ],
  },
  google: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M27.315 2h-2.037v3.946h-3.946v2.037h3.946v3.946h2.037v-3.946h3.946v-2.037h-3.946v-3.946zM15.021 18.676c-2.8-2.037-3.437-3.182-0.764-5.219 1.528-1.146 2.546-2.673 2.546-4.583 0-2.037-0.891-3.946-2.419-4.837h2.291l1.909-2.037h-8.656c-5.346 0-8.020 3.182-8.020 6.747s2.546 6.492 7.383 6.492c-0.764 1.528-0.509 2.928 0.764 3.946-8.274 0-10.056 3.692-10.056 6.492 0 3.564 4.201 5.728 9.165 5.728 6.874 0 9.547-3.564 9.547-6.619 0-2.419-0.891-4.073-3.692-6.11zM5.092 8.747c-0.382-3.055 1.146-5.346 3.437-5.346 2.291 0.127 4.328 2.546 4.71 5.601s-0.891 4.965-3.31 4.965c-2.164-0.127-4.455-2.291-4.837-5.219zM9.165 29.75c-3.437 0-5.983-2.164-5.983-4.837 0-2.546 2.928-4.837 6.365-4.71 3.819 0 6.11 2.419 6.11 4.837 0 2.673-2.037 4.71-6.492 4.71z',
      },
    ],
  },
  'hamburger-menu': {
    viewBox: '0 0 44 32',
    paths: [
      {
        d:
          'M3.2 0h37.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2h-37.6c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z M3.2 12.8h37.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2h-37.6c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z M3.2 25.6h37.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2h-37.6c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z',
      },
    ],
  },
  help: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
      },
    ],
  },
  instagram: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M27.155 2h-21.849c-1.869 0-3.306 1.437-3.306 3.306v21.992c0 1.869 1.437 3.306 3.306 3.306h21.992c1.869 0 3.306-1.437 3.306-3.306v-21.992c-0.144-1.869-1.581-3.306-3.45-3.306v0 0zM16.23 10.768c3.019 0 5.462 2.444 5.462 5.462s-2.444 5.462-5.462 5.462c-3.019 0-5.462-2.444-5.462-5.462s2.444-5.462 5.462-5.462v0 0zM27.155 26.148c0 0.575-0.431 1.15-1.15 1.15h-19.692c-0.575 0-1.15-0.431-1.15-1.15v-12.074h2.444c-0.144 0.719-0.287 1.437-0.287 2.156 0 4.887 3.881 8.768 8.768 8.768s8.768-3.881 8.768-8.768c0-0.719-0.144-1.437-0.287-2.156h2.444v12.074h0.144zM27.155 9.618c0 0.575-0.431 1.15-1.15 1.15h-3.306c-0.575 0-1.15-0.431-1.15-1.15v-3.306c0-0.575 0.431-1.15 1.15-1.15h3.306c0.575 0 1.15 0.431 1.15 1.15v3.306z',
      },
    ],
  },
  lock: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z',
      },
    ],
  },
  'next-bold': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M23.4 16l-11.4 11.4c-0.8 0.8-2 0.8-2.8 0s-0.8-2 0-2.8l8.6-8.6-8.6-8.6c-0.8-0.8-0.8-2 0-2.8s2-0.8 2.8 0l11.4 11.4z',
      },
    ],
  },
  notification: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M18 15.984l2.016 2.016v0.984h-16.031v-0.984l2.016-2.016v-4.969c0-3.094 1.641-5.625 4.5-6.328v-0.703c0-0.844 0.656-1.5 1.5-1.5s1.5 0.656 1.5 1.5v0.703c2.859 0.703 4.5 3.281 4.5 6.328v4.969zM12 21.984c-1.125 0-2.016-0.891-2.016-1.969h4.031c0 1.078-0.938 1.969-2.016 1.969z',
      },
    ],
  },
  'phone-with-fill': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M27.2 22.8l-3.6-3.6c-0.8-0.8-2-0.6-2.6 0l-1.8 1.8c-0.2 0-0.2-0.2-0.4-0.2-1.2-0.6-2.8-1.4-4.4-3.2-1.8-1.6-2.6-3.2-3.2-4.4 0-0.2-0.2-0.2-0.2-0.4l1.8-1.8c0.8-0.8 0.8-2 0-2.6l-3.6-3.6c-0.8-0.8-2-0.6-2.6 0l-1 1.2c-0.4 0.4-0.6 0.8-0.8 1.4s-0.4 1-0.4 1.6c-0.4 4 1.4 7.6 6.2 12.6 6.8 6.8 12.2 6.2 12.6 6.2 0.6 0 1-0.2 1.6-0.4s1-0.4 1.4-0.8v0l1-1c0.8-0.8 0.8-2 0-2.8z',
      },
    ],
  },
  pinterest: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M17.137 0c-8.717 0-13.137 6.261-13.137 11.418 0 3.192 1.228 6.016 3.806 6.998 0.368 0.123 0.737 0 0.859-0.491 0.123-0.368 0.246-1.105 0.368-1.473 0.123-0.491 0.123-0.614-0.246-0.982-0.737-0.859-1.228-1.964-1.228-3.56 0-4.665 3.438-8.717 8.962-8.717 4.911 0 7.612 3.069 7.612 6.998 0 5.279-2.333 9.699-5.77 9.699-1.964 0-3.315-1.596-2.947-3.56 0.491-2.333 1.596-4.788 1.596-6.507 0-1.473-0.859-2.701-2.455-2.701-1.964 0-3.56 2.087-3.56 4.788 0 1.719 0.614 2.947 0.614 2.947s-1.964 8.471-2.333 9.945c-0.737 2.947-0.123 6.63 0 6.998 0 0.246 0.368 0.246 0.491 0.123 0.123-0.246 2.455-3.069 3.315-6.016 0.246-0.859 1.351-5.034 1.351-5.034 0.614 1.228 2.455 2.333 4.42 2.333 5.893 0 9.945-5.402 9.945-12.523 0-5.648-4.665-10.681-11.663-10.681z',
      },
    ],
  },
  'prev-bold': {
    viewBox: '0 0 16 16',
    paths: [
      {
        d:
          'M4.3 8l5.7-5.7c0.4-0.4 1-0.4 1.4 0s0.4 1 0 1.4l-4.3 4.3 4.3 4.3c0.4 0.4 0.4 1 0 1.4s-1 0.4-1.4 0l-5.7-5.7z',
      },
    ],
  },
  search: {
    viewBox: '0 0 29 32',
    paths: [
      {
        d:
          'M12.657 0c-6.969 0-12.657 5.688-12.657 12.657s5.688 12.657 12.657 12.657c6.969 0 12.657-5.688 12.657-12.657s-5.688-12.657-12.657-12.657zM12.657 3.575c5.037 0 9.081 4.045 9.081 9.082s-4.045 9.081-9.082 9.081c-5.037 0-9.082-4.045-9.082-9.082s4.045-9.082 9.082-9.082z M20.914 19.842l-2.86 2.147 7.51 10.010 2.86-2.147-6.435-8.579z',
      },
    ],
  },
  spinner: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M16 0.762v0c0.727 0 1.317 0.59 1.317 1.317v5.082c0 0.727-0.59 1.317-1.317 1.317v0c-0.727 0-1.317-0.59-1.317-1.317v-5.082c0-0.727 0.59-1.317 1.317-1.317z',
      },
      {
        d:
          'M25.674 4.372v0c0.561 0.483 0.635 1.325 0.166 1.898l-3.151 3.851c-0.454 0.555-1.272 0.637-1.827 0.182-0.008-0.007-0.016-0.014-0.024-0.021v0c-0.561-0.483-0.635-1.325-0.166-1.898l3.151-3.851c0.454-0.555 1.272-0.637 1.827-0.183 0.008 0.007 0.016 0.014 0.024 0.021z',
      },
      {
        d:
          'M30.821 13.513v0c0.127 0.736-0.364 1.437-1.099 1.57l-4.755 0.86c-0.727 0.131-1.423-0.351-1.554-1.078-0.001-0.004-0.001-0.008-0.002-0.011v0c-0.127-0.736 0.364-1.437 1.099-1.57l4.755-0.86c0.727-0.131 1.423 0.351 1.554 1.078 0.001 0.004 0.001 0.008 0.002 0.011z',
      },
      {
        d:
          'M29.034 23.908v0c-0.356 0.632-1.157 0.856-1.789 0.5-0.008-0.005-0.016-0.009-0.025-0.014l-4.207-2.491c-0.642-0.38-0.862-1.203-0.496-1.853v0c0.356-0.632 1.157-0.856 1.789-0.5 0.008 0.005 0.016 0.009 0.025 0.014l4.207 2.491c0.642 0.38 0.862 1.203 0.496 1.853z',
      },
      {
        d:
          'M21.147 30.693v0c-0.673 0.251-1.421-0.091-1.672-0.763-0.002-0.007-0.005-0.013-0.007-0.020l-1.69-4.761c-0.245-0.691 0.109-1.45 0.796-1.707v0c0.673-0.251 1.421 0.091 1.672 0.763 0.002 0.007 0.005 0.013 0.007 0.020l1.69 4.761c0.245 0.691-0.109 1.45-0.796 1.707z',
      },
      {
        d:
          'M10.853 30.693v0c-0.687-0.256-1.041-1.016-0.796-1.707l1.69-4.761c0.24-0.676 0.983-1.030 1.66-0.79 0.007 0.002 0.013 0.005 0.020 0.007v0c0.687 0.256 1.041 1.016 0.796 1.707l-1.69 4.761c-0.24 0.676-0.983 1.030-1.66 0.79-0.007-0.002-0.013-0.005-0.020-0.007z',
      },
      {
        d:
          'M2.966 23.908v0c-0.366-0.65-0.145-1.473 0.496-1.853l4.207-2.491c0.624-0.369 1.43-0.163 1.799 0.461 0.005 0.008 0.010 0.016 0.014 0.025v0c0.366 0.65 0.145 1.473-0.496 1.853l-4.207 2.491c-0.624 0.369-1.43 0.163-1.799-0.461-0.005-0.008-0.010-0.016-0.014-0.025z',
      },
      {
        d:
          'M1.179 13.513v0c0.125-0.728 0.817-1.217 1.545-1.092 0.004 0.001 0.007 0.001 0.011 0.002l4.755 0.86c0.735 0.133 1.226 0.834 1.099 1.57v0c-0.125 0.728-0.817 1.217-1.545 1.092-0.004-0.001-0.008-0.001-0.011-0.002l-4.755-0.86c-0.735-0.133-1.226-0.834-1.099-1.57z',
      },
      {
        d:
          'M6.326 4.372v0c0.544-0.468 1.363-0.406 1.831 0.137 0.007 0.008 0.014 0.016 0.021 0.024l3.151 3.851c0.469 0.573 0.395 1.415-0.166 1.898v0c-0.544 0.468-1.363 0.406-1.831-0.137-0.007-0.008-0.014-0.016-0.021-0.024l-3.151-3.851c-0.469-0.573-0.395-1.415 0.166-1.898z',
      },
    ],
  },
  twitter: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M31.19 4.405c-1.215 0.81-2.7 1.35-4.186 1.62-1.215-1.215-2.97-2.025-4.861-2.025-4.186 0-7.426 3.916-6.346 8.101-5.401-0.27-10.262-2.835-13.502-6.886-1.755 2.97-0.945 6.886 2.025 8.776-1.080 0-2.025-0.27-2.97-0.81-0.135 3.105 2.16 5.941 5.266 6.481-0.945 0.27-1.89 0.27-2.97 0.135 0.81 2.565 3.24 4.456 6.076 4.591-2.7 2.16-6.211 3.105-9.722 2.7 2.97 1.89 6.346 2.97 10.127 2.97 12.152 0 19.173-10.262 18.633-19.578 1.35-0.945 2.43-2.025 3.241-3.376-1.215 0.54-2.43 0.81-3.781 1.080 1.485-0.945 2.565-2.16 2.97-3.781z',
      },
    ],
  },
  youtube: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M26.169 4.212c-4.803-0.283-15.539-0.283-20.342 0-3.39 0.283-5.086 0.848-5.509 5.086-0.424 3.108-0.424 8.617 0 11.725 0.565 4.238 2.26 4.803 5.509 5.086 4.803 0.283 15.539 0.283 20.342 0 3.39-0.283 5.086-0.848 5.509-5.086 0.424-3.108 0.424-8.617 0-11.725-0.424-4.238-2.119-4.803-5.509-5.086zM11.337 21.164v-11.725l11.443 5.933-11.443 5.792z',
      },
    ],
  },
  'exclamation-mark': {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
      },
    ],
  },
  'exclamation-mark-filled': {
    viewBox: '0 0 20 20',
    paths: [
      {
        d:
          'M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zM9 5v6h2V5H9zm0 8v2h2v-2H9z',
      },
    ],
  },
  culinary: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M5.182 27.221h21.637c0.291 0 0.453 0.333 0.277 0.565l-1.072 0.957c-0.067 0.088-0.171 0.139-0.28 0.139h-19.491c-0.109 0-0.211-0.051-0.277-0.139l-1.072-0.957c-0.179-0.232-0.013-0.565 0.277-0.565z',
      },
      {
        d:
          'M18.437 17.025c-0.032-0.997-0.8-2.349-2.437-2.349-1.635 0-2.341 1.352-2.376 2.349-4.387 0.853-7.179 4.669-7.179 9.253h19.109c0-4.584-2.728-8.4-7.117-9.253zM16 16.846c-0.403 0-1.152-0.011-1.541 0.037 0.083-0.587 0.376-1.544 1.541-1.544s1.541 0.949 1.624 1.533c-0.389-0.048-1.221-0.027-1.624-0.027zM21.952 21.643c-0.491-1.173-1.835-2.576-2.608-3.56 1.693 0.88 3.101 1.763 3.843 3.277 0.789 1.619 0.851 2.413 1.051 3.869h-1.619c-0.053-1.344-0.176-2.413-0.667-3.587z',
      },
      {
        d:
          'M17.181 3.117c0.043 0.019 0.085 0.037 0.128 0.059 0.024 0.008 0.045 0.016 0.067 0.027s0.043 0.021 0.067 0.032c0.043 0.021 0.088 0.043 0.128 0.064 0.043 0.021 0.083 0.040 0.125 0.064l0.059 0.029 0.059 0.032c0.040 0.024 0.077 0.045 0.117 0.067 0.035 0.021 0.072 0.043 0.109 0.067 0.037 0.021 0.075 0.043 0.107 0.067 0.28 0.176 0.52 0.36 0.725 0.541s0.373 0.36 0.515 0.533c0.008 0.011 0.016 0.021 0.027 0.035 0.008 0.011 0.016 0.021 0.024 0.032 0.016 0.021 0.032 0.043 0.048 0.064 0.035 0.043 0.061 0.085 0.088 0.128l0.021 0.032 0.011 0.013 0.005 0.008 0.003 0.005c0.003 0.003-0.003-0.005 0.005 0.008v0.003c0.013 0.019 0.024 0.037 0.035 0.056 0.024 0.037 0.045 0.072 0.069 0.117 0.008 0.019 0.021 0.040 0.032 0.061 0.005 0.011 0.011 0.021 0.016 0.032s0.011 0.021 0.016 0.032c0.016 0.037 0.035 0.077 0.051 0.115 0.019 0.040 0.032 0.077 0.045 0.115 0.008 0.019 0.016 0.037 0.021 0.056 0.008 0.019 0.013 0.037 0.019 0.053 0.051 0.147 0.075 0.285 0.096 0.416 0.032 0.267 0.016 0.501-0.037 0.723-0.056 0.221-0.149 0.427-0.291 0.624-0.008 0.011-0.016 0.019-0.024 0.029s-0.011 0.019-0.024 0.035c-0.021 0.024-0.043 0.051-0.064 0.077-0.021 0.024-0.043 0.048-0.064 0.069-0.024 0.024-0.043 0.048-0.067 0.069-0.093 0.093-0.197 0.181-0.312 0.267-0.117 0.088-0.245 0.171-0.387 0.253s-0.293 0.163-0.461 0.243c-0.331 0.16-0.717 0.312-1.147 0.477-0.456 0.173-0.816 0.288-1.171 0.411l-0.069 0.024c-0.021 0.005-0.043 0.013-0.064 0.021l-0.069 0.024c-0.021 0.008-0.043 0.019-0.064 0.027l-0.035 0.011-0.016 0.008-0.011 0.003-0.003 0.003h-0.003c0.016-0.011 0.005-0.003 0.008-0.005h-0.003c-0.024 0.011-0.045 0.021-0.072 0.032-0.024 0.011-0.048 0.019-0.072 0.029-0.013 0.005-0.024 0.011-0.037 0.016l-0.032 0.013c-0.043 0.021-0.088 0.037-0.131 0.059-0.045 0.021-0.091 0.045-0.139 0.069-0.093 0.048-0.189 0.101-0.285 0.163-0.192 0.123-0.392 0.269-0.581 0.464-0.189 0.197-0.371 0.437-0.512 0.741-0.139 0.301-0.24 0.669-0.227 1.112 0.003 0.221 0.037 0.461 0.112 0.717 0.075 0.259 0.192 0.533 0.365 0.824-0.211-0.352-0.363-0.691-0.467-1.016-0.056-0.163-0.093-0.32-0.128-0.477-0.008-0.037-0.013-0.077-0.021-0.115s-0.013-0.077-0.019-0.115c-0.008-0.037-0.011-0.075-0.016-0.112-0.005-0.040-0.011-0.077-0.013-0.112-0.003-0.037-0.005-0.075-0.008-0.112-0.003-0.019-0.003-0.037-0.003-0.056-0.003-0.019-0.003-0.035-0.003-0.053-0.005-0.075-0.003-0.144-0.003-0.216 0.003-0.141 0.011-0.28 0.029-0.416 0.016-0.136 0.043-0.267 0.075-0.397 0.035-0.128 0.069-0.253 0.117-0.376 0.096-0.245 0.216-0.48 0.368-0.696 0.021-0.029 0.040-0.056 0.059-0.083 0.021-0.027 0.040-0.053 0.061-0.077 0.045-0.053 0.085-0.107 0.133-0.157 0.024-0.024 0.045-0.051 0.069-0.075 0.011-0.013 0.024-0.027 0.037-0.037l0.040-0.037c0.027-0.027 0.053-0.051 0.080-0.075 0.024-0.024 0.048-0.045 0.072-0.067 0.107-0.093 0.219-0.179 0.336-0.261s0.24-0.16 0.363-0.235c0.248-0.147 0.504-0.277 0.763-0.397 0.413-0.187 0.755-0.336 1.045-0.472 0.144-0.067 0.275-0.128 0.395-0.189 0.12-0.059 0.229-0.117 0.333-0.171 0.101-0.056 0.192-0.112 0.28-0.165 0.021-0.013 0.043-0.027 0.064-0.040 0.011-0.008 0.021-0.013 0.032-0.021l0.029-0.019c0.019-0.013 0.037-0.024 0.056-0.035 0.005-0.003 0.011-0.008 0.016-0.013l0.016-0.013 0.035-0.024 0.032-0.027 0.005-0.003 0.003-0.003c0 0-0.013 0.013-0.005 0.008l0.005-0.005 0.013-0.011c0.019-0.016 0.037-0.029 0.056-0.043 0.019-0.016 0.035-0.029 0.053-0.045l0.051-0.043c0.035-0.032 0.067-0.064 0.101-0.096 0.029-0.032 0.064-0.064 0.093-0.099 0.12-0.139 0.227-0.301 0.299-0.493 0.011-0.024 0.016-0.048 0.024-0.075s0.019-0.051 0.021-0.077c0.008-0.027 0.013-0.053 0.019-0.083 0.005-0.027 0.008-0.056 0.013-0.085 0-0.013 0.003-0.029 0.005-0.043 0-0.016 0-0.029 0-0.045 0.003-0.016 0.003-0.032 0.003-0.048 0.003-0.013 0.003-0.029 0-0.045 0-0.032-0.003-0.064-0.003-0.099-0.003-0.032-0.008-0.064-0.013-0.099 0-0.016-0.003-0.035-0.008-0.053-0.003-0.019-0.008-0.037-0.011-0.056-0.003-0.011-0.005-0.019-0.008-0.029l-0.003-0.013-0.003-0.008v-0.005c-0.003-0.003 0 0.003 0 0.003-0.005-0.019-0.011-0.037-0.016-0.056-0.011-0.037-0.021-0.075-0.037-0.115-0.008-0.021-0.016-0.040-0.024-0.059-0.003-0.011-0.008-0.021-0.011-0.032-0.005-0.011-0.011-0.019-0.013-0.029-0.072-0.163-0.176-0.336-0.317-0.517s-0.323-0.371-0.555-0.565c-0.027-0.024-0.059-0.048-0.088-0.072s-0.061-0.048-0.093-0.072c-0.032-0.024-0.067-0.048-0.099-0.072-0.016-0.013-0.035-0.024-0.051-0.037-0.019-0.011-0.035-0.024-0.053-0.035-0.035-0.024-0.072-0.048-0.107-0.072-0.040-0.024-0.077-0.048-0.117-0.072-0.021-0.011-0.040-0.024-0.059-0.035-0.021-0.011-0.040-0.021-0.061-0.035-0.037-0.021-0.077-0.045-0.117-0.067z',
      },
      {
        d:
          'M14.123 3.332c0.029 0.013 0.059 0.027 0.088 0.040 0.016 0.005 0.029 0.011 0.045 0.019 0.013 0.008 0.029 0.013 0.043 0.021 0.032 0.013 0.061 0.029 0.091 0.043 0.027 0.013 0.056 0.029 0.083 0.043 0.013 0.008 0.029 0.016 0.043 0.021l0.040 0.024c0.027 0.013 0.053 0.029 0.077 0.043 0.027 0.016 0.051 0.032 0.077 0.045 0.024 0.016 0.048 0.032 0.072 0.045 0.192 0.123 0.355 0.248 0.493 0.371 0.141 0.123 0.256 0.245 0.349 0.365 0.008 0.005 0.013 0.013 0.019 0.021l0.019 0.021c0.011 0.016 0.021 0.029 0.032 0.043 0.021 0.029 0.040 0.059 0.061 0.088 0.003 0.008 0.008 0.013 0.013 0.021l0.008 0.011 0.003 0.005 0.003 0.003c0 0.003-0.003-0.003 0.003 0.005v0.003c0.008 0.013 0.016 0.027 0.024 0.037 0.016 0.027 0.032 0.051 0.045 0.080 0.016 0.029 0.032 0.059 0.045 0.085 0.011 0.027 0.024 0.053 0.035 0.080 0.013 0.027 0.021 0.051 0.032 0.077 0.005 0.013 0.008 0.024 0.013 0.037s0.008 0.027 0.013 0.037c0.032 0.101 0.051 0.195 0.064 0.285 0.021 0.179 0.011 0.341-0.024 0.491-0.037 0.152-0.104 0.291-0.2 0.424l-0.013 0.021c-0.005 0.008-0.011 0.013-0.019 0.021-0.013 0.019-0.029 0.037-0.043 0.053-0.016 0.019-0.029 0.032-0.045 0.048-0.013 0.016-0.029 0.032-0.045 0.048-0.061 0.064-0.133 0.123-0.213 0.181-0.157 0.12-0.349 0.229-0.576 0.339s-0.491 0.213-0.781 0.325c-0.312 0.117-0.555 0.195-0.8 0.28-0.029 0.011-0.061 0.019-0.091 0.032-0.029 0.011-0.061 0.021-0.091 0.032l-0.024 0.008-0.011 0.005-0.005 0.003h-0.003c0.011-0.005 0.003 0 0.003-0.003-0.016 0.008-0.032 0.016-0.048 0.021-0.019 0.008-0.035 0.013-0.051 0.021-0.008 0.003-0.016 0.008-0.024 0.011s-0.016 0.005-0.024 0.011c-0.029 0.011-0.059 0.027-0.088 0.037-0.032 0.016-0.064 0.032-0.096 0.048-0.061 0.032-0.128 0.069-0.192 0.112-0.131 0.083-0.267 0.184-0.397 0.317-0.128 0.133-0.253 0.296-0.349 0.501-0.093 0.208-0.163 0.459-0.155 0.76 0.003 0.149 0.027 0.315 0.077 0.491 0.051 0.173 0.131 0.363 0.248 0.56-0.144-0.24-0.248-0.472-0.317-0.693-0.072-0.221-0.115-0.432-0.133-0.635-0.005-0.051-0.011-0.101-0.011-0.149-0.003-0.051-0.003-0.099-0.003-0.147 0.003-0.096 0.008-0.192 0.021-0.285 0.011-0.091 0.029-0.181 0.051-0.269s0.048-0.173 0.080-0.256c0.064-0.168 0.147-0.328 0.251-0.475 0.053-0.075 0.109-0.149 0.171-0.216 0.016-0.019 0.032-0.035 0.048-0.051 0.016-0.019 0.037-0.035 0.053-0.053 0.019-0.016 0.037-0.035 0.056-0.051 0.016-0.016 0.032-0.029 0.048-0.043 0.072-0.067 0.149-0.125 0.229-0.181s0.163-0.107 0.248-0.157 0.341-0.189 0.52-0.272c0.28-0.128 0.515-0.229 0.712-0.32 0.096-0.045 0.187-0.091 0.269-0.131s0.155-0.080 0.224-0.117c0.069-0.037 0.133-0.075 0.195-0.112 0.013-0.011 0.029-0.019 0.043-0.027l0.021-0.016 0.019-0.011c0.013-0.011 0.027-0.016 0.040-0.027 0.003 0 0.005-0.003 0.011-0.008l0.032-0.024 0.024-0.019 0.003-0.003h0.003c0-0.003-0.008 0.008-0.005 0.005v-0.003l0.005-0.003 0.011-0.008c0.011-0.008 0.024-0.019 0.035-0.027 0.016-0.011 0.027-0.021 0.037-0.032l0.037-0.029c0.021-0.021 0.043-0.043 0.067-0.064 0.021-0.021 0.043-0.045 0.064-0.069 0.083-0.093 0.155-0.203 0.203-0.336 0.024-0.067 0.045-0.136 0.053-0.216 0-0.011 0.003-0.021 0.003-0.032 0.003-0.008 0.003-0.019 0.003-0.029 0-0.021 0.003-0.043 0.003-0.064-0.003-0.021-0.003-0.045-0.005-0.067 0-0.021-0.003-0.043-0.005-0.067-0.003-0.021-0.011-0.051-0.016-0.075-0.003-0.008-0.003-0.013-0.005-0.019v-0.011l-0.003-0.005v-0.003c-0.003-0.013-0.008-0.027-0.011-0.037-0.008-0.027-0.016-0.053-0.027-0.080-0.005-0.011-0.011-0.024-0.016-0.040-0.003-0.005-0.005-0.013-0.008-0.019-0.003-0.008-0.005-0.013-0.008-0.021-0.051-0.109-0.12-0.229-0.216-0.352-0.096-0.125-0.221-0.253-0.379-0.387-0.019-0.016-0.040-0.032-0.059-0.048-0.021-0.016-0.043-0.032-0.064-0.051-0.021-0.016-0.045-0.032-0.067-0.048-0.013-0.008-0.024-0.016-0.035-0.024-0.013-0.008-0.024-0.016-0.037-0.024-0.024-0.016-0.048-0.032-0.075-0.051-0.024-0.016-0.051-0.032-0.077-0.048-0.013-0.008-0.027-0.016-0.043-0.024-0.013-0.008-0.024-0.016-0.037-0.024-0.029-0.013-0.056-0.029-0.083-0.045z',
      },
      {
        d:
          'M18.437 17.025c-0.032-0.997-0.8-2.349-2.437-2.349-1.635 0-2.341 1.352-2.376 2.349-4.387 0.853-7.179 4.669-7.179 9.253h19.109c0-4.584-2.728-8.4-7.117-9.253zM16 16.846c-0.403 0-1.152-0.011-1.541 0.037 0.083-0.587 0.376-1.544 1.541-1.544s1.541 0.949 1.624 1.533c-0.389-0.048-1.221-0.027-1.624-0.027zM21.952 21.643c-0.491-1.173-1.835-2.576-2.608-3.56 1.693 0.88 3.101 1.763 3.843 3.277 0.789 1.619 0.851 2.413 1.051 3.869h-1.619c-0.053-1.344-0.176-2.413-0.667-3.587z',
      },
    ],
  },
  difficult: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M17.486 23.367v-0.782c-0.616 0.547-1.445 1.046-2.634 1.046-2.657 0-4.838-1.994-4.838-6.643 0-3.725 1.754-6.336 4.838-6.336 1.092 0 2.040 0.427 2.634 0.974v-3.917l3.275-1.636v17.295h-3.275zM17.486 14.804c-0.499-0.688-1.256-1.069-2.204-1.069-1.258 0-1.946 1.092-1.946 3.181 0 2.562 0.854 3.628 2.135 3.628 1.020 0 1.542-0.427 2.015-1.043v-4.697z',
      },
      {
        d:
          'M16 2.667c7.352 0 13.333 5.981 13.333 13.333s-5.981 13.333-13.333 13.333-13.333-5.981-13.333-13.333 5.981-13.333 13.333-13.333zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16v0z',
      },
    ],
  },
  easy: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M21.407 16.013c0-3.564-1.925-6.512-5.252-6.512-3.16 0-5.561 2.687-5.561 6.512 0 3.943 2.281 6.487 5.871 6.487 1.665 0 3.47-0.736 4.467-2.020l-2.329-1.948c-0.473 0.547-1.235 0.88-2.138 0.88-1.189 0-2.447-0.642-2.567-2.352h7.464c0.023-0.238 0.046-0.573 0.046-1.046zM18.223 14.586h-4.278c0.118-1.258 0.854-2.232 2.043-2.232 1.473 0 2.14 1.115 2.235 2.232z',
      },
      {
        d:
          'M16 2.667c7.352 0 13.333 5.981 13.333 13.333s-5.981 13.333-13.333 13.333-13.333-5.981-13.333-13.333 5.981-13.333 13.333-13.333zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16v0z',
      },
    ],
  },
  moderate: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M24.922 22.36h-3.273v-6.738c0-2.232-0.642-2.897-1.994-2.897s-2.017 0.665-2.017 2.825v6.809h-3.275v-6.738c0-2.232-0.639-2.897-1.992-2.897s-2.017 0.665-2.017 2.825v6.809h-3.275v-12.457h3.275v0.831c0.57-0.593 1.424-1.092 2.728-1.092 1.59 0 2.516 0.45 3.442 1.588 0.854-0.877 1.9-1.588 3.963-1.588 3.178 0 4.436 2.184 4.436 5.694v7.024z',
      },
      {
        d:
          'M16 2.536c7.352 0 13.333 5.981 13.333 13.333s-5.981 13.333-13.333 13.333-13.333-5.981-13.333-13.333 5.981-13.333 13.333-13.333zM16-0.131c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16v0z',
      },
    ],
  },
  wheelchair: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M20.628 22.994h-2.728l-1.235-4.889c-0.238-0.972-0.568-2.35-0.665-2.943-0.095 0.593-0.427 1.971-0.662 2.943l-1.235 4.889h-2.728l-3.582-12.457h3.319l1.092 4.602c0.215 0.949 0.501 2.255 0.593 2.848 0.097-0.619 0.404-1.874 0.667-2.848l1.232-4.602h2.705l1.232 4.602c0.261 0.974 0.57 2.23 0.665 2.848 0.095-0.593 0.381-1.9 0.593-2.848l1.092-4.602h3.227l-3.582 12.457z',
      },
      {
        d:
          'M16 2.667c7.352 0 13.333 5.981 13.333 13.333s-5.981 13.333-13.333 13.333-13.333-5.981-13.333-13.333 5.981-13.333 13.333-13.333zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16v0z',
      },
    ],
  },
  'beach-stay': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M29.775 16.488c-0.323-0.427-1.048-0.64-1.6-0.181-1.509 1.256-6.045 5.048-6.045 5.048l-0.587-0.195c0 0 5.413-5.157 6.981-6.667 0.768-0.741 0.349-1.515-0.115-1.885-0.557-0.443-1.285-0.541-1.819 0.16-1.091 1.432-6.093 8.064-6.093 8.064l-0.592-0.099c0 0 5.464-8.123 6.547-9.757 0.584-0.888 0.128-1.723-0.619-2.139-0.792-0.443-1.768-0.451-2.184 0.491-0.928 2.112-4.773 11.219-4.773 11.219l-0.576-0.051c0 0 3.659-9.792 4.563-12.229 0.461-1.251-0.168-1.875-1.395-2.197-1.264-0.333-2.053 0.099-2.272 1.419-0.44 2.667-1.955 12.915-1.955 12.915l-0.557-0.016c0 0 1.165-10.643 1.491-13.923 0.147-1.491-1.189-1.643-2.101-1.637-0.011 0-0.059 0-0.072 0-0.016 0-0.061 0-0.075 0-0.912-0.005-2.248 0.147-2.101 1.637 0.325 3.28 1.491 13.923 1.491 13.923l-0.557 0.016c0 0-1.515-10.248-1.955-12.915-0.216-1.32-1.008-1.752-2.272-1.419-1.227 0.323-1.856 0.947-1.392 2.197 0.901 2.437 4.56 12.229 4.56 12.229l-0.576 0.051c0 0-3.845-9.107-4.773-11.219-0.416-0.941-1.392-0.933-2.184-0.491-0.747 0.416-1.203 1.251-0.616 2.139 1.080 1.635 6.544 9.757 6.544 9.757l-0.592 0.099c0 0-5-6.632-6.093-8.064-0.533-0.701-1.261-0.603-1.819-0.16-0.464 0.371-0.883 1.144-0.115 1.885 1.565 1.509 6.984 6.632 6.984 6.632l-0.587 0.229c0 0-4.536-3.792-6.045-5.048-0.555-0.459-1.277-0.245-1.603 0.181-0.357 0.469-0.459 1.243 0.2 1.637 1.365 0.813 3.371 1.896 6.456 3.704-0.52 0.352-0.92 0.827-0.92 1.379 0 1.003 1.744 1.576 3.083 1.576 0.008 0.147 0.253 0.563 0.477 0.813 0.835 0.939 2.544 1.576 4.48 1.576 1.933 0 3.643-0.637 4.477-1.576 0.224-0.251 0.469-0.667 0.477-0.813 1.339 0 3.083-0.573 3.083-1.576 0-0.552-0.365-0.995-0.885-1.344 3.085-1.808 5.059-2.925 6.421-3.739 0.659-0.395 0.557-1.168 0.2-1.637z',
      },
    ],
  },
  culture: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M23.116 23.903c0.64 0 1.16 0.52 1.16 1.16 0 0.637-0.52 1.157-1.16 1.157h-14.232c-0.637 0-1.157-0.52-1.157-1.157 0-0.64 0.52-1.16 1.157-1.16h14.232z',
      },
      {
        d:
          'M14.36 10.856c0.397 0 0.72 0.323 0.72 0.72v10.944c0 0.397-0.323 0.72-0.72 0.72s-0.72-0.323-0.72-0.72v-10.944c-0-0.397 0.323-0.72 0.72-0.72z',
      },
      {
        d:
          'M17.633 10.856c0.397 0 0.72 0.323 0.72 0.72v10.944c0 0.397-0.323 0.72-0.72 0.72s-0.72-0.323-0.72-0.72v-10.944c-0-0.397 0.323-0.72 0.72-0.72z',
      },
      {
        d:
          'M23.373 5.78c1.757 0 4.195 1.605 4.195 4.619 0 2.845-2.155 3.853-4 3.853-0.584 0-1.2-0.16-1.728-0.448l-0.213-0.117v8.835c0 0.395-0.323 0.72-0.72 0.72s-0.72-0.325-0.72-0.72v-11.525l0.005-0.013v-0.029c0.032-1.64 1.584-2.379 2.68-2.379 1.016 0 2.093 0.611 2.093 1.741 0 1.171-0.493 1.739-1.509 1.739-0.896 0-1.456-0.496-1.456-1.296 0-0.32-0.115-0.48-0.344-0.48-0.077 0-0.331 0.032-0.336 0.477-0.003 0.469 0.16 1.141 0.635 1.621 0.381 0.384 0.891 0.579 1.517 0.579 1.272 0 2.64-0.84 2.64-2.688 0-1.469-1.229-3.059-3.216-3.059-1.613 0-2.267 0.536-2.963 1.101-0.776 0.635-1.581 1.293-3.933 1.293s-3.157-0.659-3.936-1.293c-0.693-0.565-1.347-1.101-2.96-1.101-1.987 0-3.216 1.589-3.216 3.059 0 1.848 1.368 2.688 2.64 2.688 1.701 0 2.152-1.437 2.152-2.197 0-0.157 0-0.48-0.325-0.48-0.357 0-0.357 0.299-0.357 0.48 0 0.787-0.568 1.296-1.451 1.296-0.699 0-1.515-0.453-1.515-1.739 0-1.091 1.067-1.741 2.099-1.741 1.077 0 2.68 0.645 2.68 2.427 0 0.011 0 0.019-0.003 0.027 0 0.013 0 0.027-0.003 0.043v11.451c0 0.395-0.32 0.72-0.717 0.72s-0.72-0.325-0.72-0.72v-8.832l-0.213 0.117c-0.528 0.288-1.141 0.445-1.723 0.445-1.848 0-4-1.008-4-3.853 0-3.013 2.435-4.619 4.195-4.619h14.747z',
      },
    ],
  },
  'local-life': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M23.121 11.815v-5.507c0-0.251-0.205-0.456-0.456-0.456h-2.693c-0.251 0-0.456 0.205-0.456 0.456v1.901l3.605 3.605zM15.999 5.852l-10.515 10.517h3.397v9.323c0 0.251 0.205 0.456 0.456 0.456h4.597v-0.445c0-0.003 0.005-0.005 0.005-0.011v-7.325c0-0.251 0.203-0.456 0.453-0.456h3.213c0.251 0 0.456 0.205 0.456 0.456v0.195h-0.005v7.587h4.608c0.251 0 0.456-0.205 0.456-0.456v-9.323h3.395l-10.517-10.517z',
      },
    ],
  },
  'natural-world': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M21.801 5.761c-0.152-0.237-0.397-0.189-0.536 0-0.629 0.84-1.72 2.333-2.464 3.205-0.835-1.419-2.285-4.029-2.805-4.029-0.595 0-2.288 2.688-3.2 4.029-0.768-1.091-1.691-2.656-2.109-3.221-0.123-0.165-0.368-0.171-0.483 0-0.867 1.269-1.245 2.483-1.245 4.133 0 4.723 3.104 8.781 7.048 8.781 4.075 0 7.037-4.008 7.037-8.709-0-1.32-0.573-3.16-1.243-4.189zM18.98 27.063c4.744 0 6.904-4.243 6.363-5.037-0.437-0.651-3.656-0.037-5.968 1.779-2.117 1.667-3.059 3.259-0.395 3.259zM12.625 23.804c-2.312-1.816-5.528-2.429-5.968-1.779-0.539 0.795 1.621 5.037 6.363 5.037 2.669 0 1.723-1.592-0.395-3.259zM16.633 19.287h-1.264v7.773h1.264v-7.773z',
      },
    ],
  },
  'privileged-access': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M29.069 13.98h-14.864c-0.771-2.443-3.056-4.219-5.755-4.219-3.331 0-6.029 2.704-6.029 6.035 0 3.333 2.699 6.029 6.029 6.029 2.741 0 5.051-1.824 5.787-4.328h5.277v4.232c0 0.28 0.229 0.509 0.507 0.509h2.037c0.28 0 0.507-0.229 0.507-0.509v-4.739h1.712c0.072 0 0.147 0.008 0.221 0.021v4.717c0 0.28 0.229 0.509 0.507 0.509h2.037c0.277 0 0.504-0.229 0.504-0.509v-4.232h1.523c0.28 0 0.509-0.23 0.509-0.507v-2.504c0-0.277-0.229-0.507-0.509-0.507zM8.451 18.527c-1.451 0-2.627-1.176-2.627-2.627 0-1.453 1.176-2.632 2.627-2.632 1.453 0 2.629 1.179 2.629 2.632 0 1.451-1.176 2.627-2.629 2.627z',
      },
    ],
  },
  sightseeing: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M6.179 17.489l-0.821 6.547v1.885c0 0 0.544 0.448 3.232 0.448s3.715-0.448 3.715-0.448v-1.885c0 0-0.221-2.869-0.723-6.547 0 0 0.499-0.125 2.432-0.125v-8.763l0.333-0.6v-2.069c0 0-0.077-0.301-2.165-0.301-1.997 0-2.16 0.301-2.16 0.301v2.069l0.349 0.6v1.779c0 0-2.613-0.008-3.192 0.296 0 0-0.6 0.848-0.872 2.763s-0.128 4.051-0.128 4.051zM25.699 13.439c-0.272-1.915-0.872-2.763-0.872-2.763-0.576-0.304-3.192-0.296-3.192-0.296v-1.779l0.347-0.6v-2.069c0 0-0.163-0.301-2.16-0.301-2.085 0-2.163 0.301-2.163 0.301v2.069l0.331 0.6v8.763c1.933 0 2.435 0.125 2.435 0.125-0.504 3.677-0.725 6.547-0.725 6.547v1.885c0 0 1.027 0.448 3.715 0.448 2.691 0 3.229-0.448 3.229-0.448v-1.885l-0.819-6.547c0-0 0.147-2.136-0.125-4.051zM14.872 10.38v6.984h2.221v-6.984h-2.221z',
      },
    ],
  },
  'special-interest': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M20.623 4.848c-3.973 0-7.192 3.221-7.192 7.192s3.219 7.192 7.192 7.192c3.971 0 7.192-3.221 7.192-7.192s-3.221-7.192-7.192-7.192zM20.622 17.237c-2.869 0-5.195-2.328-5.195-5.197s2.325-5.195 5.195-5.195 5.195 2.325 5.195 5.195-2.325 5.197-5.195 5.197z',
      },
      {
        d:
          'M12.825 17.112l0.242 0.277-7.984 6.707-0.211-0.245-0.688 0.576 2.363 2.725 0.688-0.579-0.203-0.232 7.928-6.768 0.227 0.261 0.688-0.576-2.363-2.725z',
      },
    ],
  },
  'working-world': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M25.658 16.043v-0.003l-0.088-1.739-0.48-9.472h-3.952l-0.376 10.736h-1.685l-0.547-10.736h-3.949l-0.379 10.736h-7.923c-0.264 0-0.48 0.216-0.48 0.477v10.651c0 0.264 0.216 0.477 0.48 0.477h19.467c0.261 0 0.467-0.213 0.453-0.477l-0.541-10.651zM11.344 24.259h-2.056v-1.941h2.056v1.941zM11.344 20.888h-2.056v-1.944h2.056v1.944zM14.885 24.259h-2.056v-1.941h2.056v1.941zM14.885 20.888h-2.056v-1.944h2.056v1.944zM18.432 24.259h-2.059v-1.941h2.059v1.941zM18.432 20.888h-2.059v-1.944h2.059v1.944zM21.976 24.259h-2.056v-1.941h2.056v1.941zM21.976 20.888h-2.056v-1.944h2.056v1.944z',
      },
    ],
  },
  'after-dark': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M16.141 3.423c0.595 0 1.072 0.48 1.072 1.072s-0.477 1.072-1.072 1.072c-0.592 0-1.072-0.48-1.072-1.072s0.48-1.072 1.072-1.072zM4.109 3.423c0.595 0 1.075 0.48 1.075 1.072s-0.48 1.072-1.075 1.072c-0.592 0-1.072-0.48-1.072-1.072s0.48-1.072 1.072-1.072zM15.309 28.311c-5.512 1.275-11.013-2.163-12.288-7.675-1.227-5.301 1.907-10.581 7.053-12.112-2.075 2.389-3.019 5.699-2.253 9.016 1.275 5.512 6.776 8.949 12.291 7.675 0.211-0.048 0.413-0.115 0.619-0.179-1.371 1.584-3.227 2.768-5.421 3.275zM22.157 14.037c-0.592 0-1.072-0.483-1.072-1.072 0-0.592 0.48-1.072 1.072-1.072 0.595 0 1.075 0.48 1.075 1.072 0 0.589-0.48 1.072-1.075 1.072zM28.173 5.567c-0.592 0-1.072-0.48-1.072-1.072s0.48-1.072 1.072-1.072c0.592 0 1.072 0.48 1.072 1.072s-0.48 1.072-1.072 1.072z',
      },
    ],
  },
  'guest-favourite': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M16 4.664l2.864 8.589 9.056 0.069-7.285 5.379 2.731 8.635-7.365-5.267-7.365 5.267 2.731-8.635-7.285-5.379 9.056-0.069z',
      },
    ],
  },
  'meal-included': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M12.685 12.605l-0.456 0.147 0.797 13.477c0 2.304-1.293 2.333-1.76 2.333h-0.091c-0.467 0-1.76-0.029-1.76-2.333l0.797-13.475-0.459-0.149c-0.901-0.197-1.227-0.685-1.227-1.533l0.307-6.104c0-0.717 0.307-1.317 0.949-1.485v6.293c0 0.315 0.187 0.573 0.416 0.573s0.416-0.259 0.416-0.573l0.197-6.339h0.816l0.197 6.339c0 0.315 0.184 0.573 0.416 0.573 0.229 0 0.416-0.259 0.416-0.573v-6.291c0.616 0.168 0.848 0.768 0.848 1.483l0.405 6.104c0 0.848-0.347 1.379-1.227 1.533zM21.491 12.899l0.787 13.331c0 2.304-1.293 2.333-1.76 2.333h-0.088c-0.467 0-1.763-0.029-1.763-2.333l0.787-13.32c-1.565-0.549-1.979-2.344-1.979-3.056 0 0-0.040-6.416 3.043-6.416 2.995 0 2.955 6.416 2.955 6.416-0 0.707-0.435 2.483-1.981 3.045z',
      },
    ],
  },
  shopping: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M23.112 11.401c0-0.432-0.363-0.781-0.808-0.781h-2.459c-0.043-1.555-0.248-3.117-1.264-4.104-0.643-0.627-1.541-0.941-2.661-0.941-1.123 0-2.019 0.315-2.659 0.939-1.019 0.989-1.213 2.555-1.251 4.107h-2.312c-0.448 0-0.808 0.349-0.808 0.781l-0.925 14.245c0 0.432 0.363 0.779 0.805 0.779h14.459c0.445 0 0.805-0.347 0.805-0.779l-0.923-14.245zM13.217 10.621c0.032-1.312 0.189-2.589 0.899-3.28 0.411-0.397 1-0.595 1.805-0.595 0.803 0 1.395 0.197 1.808 0.597 0.709 0.691 0.875 1.965 0.912 3.277h-5.424z',
      },
    ],
  },
  'snack-included': {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M10.248 5.701c0.451-0.507 3.136 0.384 4.909 2.203 1.624 1.664 2.253 3.131-0.032 2.832-4.059-0.541-5.427-4.411-4.877-5.035zM24.72 18.314c-0.368 4.568-3.973 8.125-5.797 8.125-1.205 0-1.531-0.528-2.816-0.528-1.184 0-1.621 0.528-2.811 0.528-2.813 0-5.731-3.944-6.019-7.92-0.403-5.563 2.968-7.397 5.448-7.397 2.12 0 2.717 1.163 3.381 1.163 0.741 0 0.824-1.181 3.013-1.181 2.352 0 6.043 1.725 5.6 7.211z',
      },
    ],
  },
  unesco: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M24.599 23.181v-0.408c0-0.189-0.155-0.344-0.341-0.344h-0.491l-0.315-10.528c0.085 0.035 0.181 0.056 0.296 0.056 1.029 0 1.112-1.219 0.336-1.499h4.275l-12.357-4.8-12.36 4.8h4.192c-0.776 0.28-0.693 1.499 0.339 1.499 0.115 0 0.213-0.021 0.299-0.059l-0.315 10.531h-0.496c-0.187 0-0.341 0.155-0.341 0.344v0.408c0 0.011 0.005 0.021 0.008 0.035h-2.576v3.125h22.499v-3.125h-2.659c0.003-0.013 0.008-0.024 0.008-0.035zM14.653 22.43h-0.496c-0.189 0-0.341 0.155-0.341 0.344v0.405c0 0.013 0.005 0.024 0.005 0.037h-2.221c0.003-0.013 0.008-0.024 0.008-0.037v-0.405c0-0.189-0.155-0.344-0.344-0.344h-0.488l-0.317-10.528c0.085 0.032 0.184 0.056 0.296 0.056 1.032 0 1.115-1.221 0.336-1.499h3.24c-0.779 0.277-0.696 1.499 0.336 1.499 0.115 0 0.216-0.024 0.301-0.059l-0.315 10.531zM21.147 22.43h-0.493c-0.187 0-0.341 0.155-0.341 0.344v0.405c0 0.013 0.005 0.024 0.008 0.037h-2.227c0.003-0.013 0.008-0.024 0.008-0.037v-0.405c0-0.189-0.155-0.344-0.341-0.344h-0.488l-0.317-10.528c0.085 0.032 0.184 0.056 0.296 0.056 1.032 0 1.115-1.221 0.336-1.499h3.24c-0.779 0.277-0.693 1.499 0.336 1.499 0.117 0 0.216-0.024 0.301-0.059l-0.317 10.531z',
      },
    ],
  },
  active: {
    viewBox: '0 0 32 32',
    paths: [
      {
        d:
          'M17.32 3.393c-1.179 0-2.133 0.96-2.133 2.133 0 1.179 0.955 2.136 2.133 2.136s2.133-0.957 2.133-2.136c0-1.173-0.955-2.133-2.133-2.133zM13.672 8.428l-1.941-0.435-1.819 5.272 2.64 0.547 1.12-5.384zM24.483 15.111c0-0.363-0.216-0.675-0.528-0.813v-1.592h-0.731v1.592c-0.109 0.051-0.205 0.123-0.285 0.211l-2.589-1.803-1.299-2.365c0 0-0.296-1.696-1.84-2.208-2.525-0.837-2.96 0.349-3.365 2.589l-0.619 3.243-1.891 6.949-3.819 6.352 1.635 0.845 4.296-5.261 1.976-3.995 1.944 2.656 1.163 7.096h1.987l-0.896-8.491-2.301-4.648 0.957-2.696 1.336 1.312 3.139 1.293c0.077 0.24 0.245 0.437 0.472 0.541v12.688h0.731v-12.688c0.312-0.139 0.528-0.448 0.528-0.808z',
      },
    ],
  },
  calendar: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z',
      },
    ],
  },
  download: {
    viewBox: '0 0 24 24',
    paths: [
      {
        d:
          'M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64    c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472    c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z',
      },
    ],
  },
};

const Icon = ({ name, focusable, dataId }) => {
  const icon = icons[name];
  if (icon) {
    const { viewBox, paths } = icon;
    return (
      <div className="container-icon" data-id={dataId}>
        <svg
          focusable={focusable}
          className={`icon icon-${name}`}
          viewBox={viewBox}
        >
          {/* eslint-disable react/no-array-index-key */}
          {paths.map((path, i) => (
            <path {...path} key={i} />
          ))}
        </svg>
      </div>
    );
  }
  return null;
};

Icon.defaultProps = {
  focusable: false,
  dataId: undefined,
};

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  focusable: PropTypes.bool,
  dataId: PropTypes.string,
};

export default Icon;
